import React from 'react';

import { Box, useTheme } from '@mui/material';

import { AccordionSection } from '~/components/AccordionSection';
//import { IConfigurationOptionGroup } from '~/domain/IConfigurationOptionGroup';
import { IConfigurationTrim } from '~/domain/IConfigurationTrim';

import { ConfigurationOptionTrims } from './ConfigurationOptionTrims';

interface IVehicleConfigurations {
  client: string | undefined,
  year: string | undefined,
  vehicle: string | undefined,
  trims: IConfigurationTrim[] | undefined,
}

export const VehicleConfigurationsTrims = React.memo<IVehicleConfigurations>(function VehicleConfigurations(props) {
  const {
    client,
    year,
    trims,
    vehicle,
  } = props;

  const { palette } = useTheme();

  //sort trim objects
  let newtrims:IConfigurationTrim[] = [];
  const checkedtrims:IConfigurationTrim[] = [];
  if(trims){
    newtrims = trims.sort((a, b) => (a.name < b.name ? -1 : 1));
    for(let i = 0; i<newtrims.length;i++){
      //condition for empty colors arrays
      if(newtrims[i].colors.length>0){
        checkedtrims.push(newtrims[i]);
      }
    }
  }
  
  return (

    <>

      <Box sx={{ overflow: 'auto' }}>
        <AccordionSection
          contenttype={'model'}
          defaultExpanded = {true}
          label={
            <>
              <span style={{ color: palette.primary.dark, marginRight: 10 }}>
                {year + ' ' + vehicle}
              </span>
            </>
          }
        >

          <>
            <ConfigurationOptionTrims
              name={vehicle}
              code={vehicle}
              client={client}
              trims={checkedtrims}
            />
          </>
        </AccordionSection>
      </Box>
    </>

  );
});
